import React from "react";
import { useMsal } from "@azure/msal-react";

const UnauthorizedPage = () => {
  const { instance } = useMsal();

  const deniedEmail =
    localStorage.getItem("ssoAccessDeniedEmail") ||
    instance?.getActiveAccount?.()?.username ||
    instance?.getAllAccounts?.()?.[0]?.username ||
    "";

  const handleSignOut = async () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("ssoAccessDeniedEmail");
    try {
      const accounts = instance?.getAllAccounts?.() || [];
      if (accounts.length > 0) {
        await instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: window.location.origin + "/login",
        });
        return;
      }
    } catch (e) {
      console.error("MSAL logout failed", e);
    }
    window.location.href = "/login";
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-md w-full max-w-md text-center">
        <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4 bg-red-50">
          <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M12 9v2m0 4h.01M4.93 19h14.14a2 2 0 001.74-3l-7.07-12a2 2 0 00-3.48 0L3.19 16a2 2 0 001.74 3z" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-primary-800 mb-2">Access Denied</h1>
        <p className="text-sm text-gray-600 mb-2">
          Your account does not have access to this application.
        </p>
        {deniedEmail && (
          <p className="text-sm font-medium text-primary-800 break-all mb-4">{deniedEmail}</p>
        )}
        <p className="text-xs text-gray-500 mb-6">
          Please contact your administrator if you believe this is a mistake.
        </p>
        <button
          onClick={handleSignOut}
          className="w-full bg-primary-800 text-white py-2.5 rounded-md hover:bg-primary-800/80 text-sm transition"
        >
          Sign in with a different account
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
